<template>
  <div>
   <head-nav v-if="!global.isPhone()" :key="Math.random()"/>
   <router-view  :plates="plates" v-if="plates.length>0"></router-view>
   <footer-nav v-if="!global.isPhone()" :key="Math.random()"/>
   <head-nav-m v-if="global.isPhone()"/>
   
    <!-- Back To Top -->
    <a href="#" id="back-to-top">
        <i class="fal fa-angle-double-up"></i>
    </a>
  </div>
</template>

<script>
import jwt_decode from "jwt-decode";
import global from "../components/PublicComs/Common.vue";
import HeadNav from "../components/PublicComs/HeadNav.vue";
import FooterNav from "../components/HomeComs/FooterNav.vue";
import HeadNavM from "../components/PublicComs/HeadNav_M.vue";
// import AppToTop from "../components/PublicComs/AppToTop.vue";
export default {
  data() {
    return {
      timer: "",
      global,
      webdata: {},
      plates: [],
    };
  },

  components: { HeadNav, FooterNav ,HeadNavM},

  computed: {},
  beforeDestroy() {
    clearInterval(this.timer);
  },
  created(){
     
  },
  beforeMount(){
    if(localStorage.onlymycourseCySd=="1")
      this.$root.onlymycourse = true;
    else 
    this.$root.onlymycourse = false;
     this.$root.hasCourse =localStorage.hasCourseCySd.split(",");
    if(this.$route.path!="/queryResult"&&this.$route.path!="/queryinfo"&&this.$route.path!="/achieveview"){
      this.$axios.get("/api/auth/me").then(res => {
              let arrhasCourse = [];
                for (var i = 0; i <res.data.data.needexaminee.length; i++)
                {
                  arrhasCourse.push(res.data.data.needexaminee[i].coursetype);
                }
                this.$root.hasCourse =arrhasCourse;
              this.$root.ischeckface = res.data.data.ischeckface;
              this.$root.onlymycourse = res.data.data.onlymycourse;
                        this.$root.buytype = res.data.data.buytype;
                
            })
    }
  },
  mounted() {
    this.$axios
      .get("/api/categorys?page=1&limit=30&firstView=1")
      .then((res) => {
        if (res.data) {
          this.$nextTick(function() {
            this.plates = res.data.data;
          });
        }
      });
     
      var back = $("#back-to-top"),
      body = $("body, html");
      $(window).on('scroll', function () {
          if ($(window).scrollTop() > $(window).height()) {
              back.css({
                  bottom: '20px',
                  opacity: '1',
                  visibility: 'visible'
              });
          } else {
              back.css({
                  bottom: '-20px',
                  opacity: '0',
                  visibility: 'hidden'
              });
          }

      });
      body.on("click", "#back-to-top", function (e) {
          e.preventDefault();
          body.animate({
              scrollTop: 0
          }, 800);
          return false;
      });

  },

  methods: {},
};
</script>
<style scoped>
</style>
